var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1370a035939ccb174ad83f85558661db.js').default;
var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/de273e8f48200bdbe5773ea53758d726.js').default;
var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dec4b14b47dbae0233a438449d6ea464.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    